const AskConfirmationModal = ({
  handleClose,
  handleConfirm,
  isSubmitting = false,
  message,
}) => {
  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Confirmation</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="modal-body fs-9">{message}</div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={handleConfirm}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span
                    className="spinner-border spinner-custom-size me-1"
                    aria-hidden="true"
                  ></span>
                ) : null}
                <span role="status">Confirm</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default AskConfirmationModal;
